import IndividualUnit from './IndividualUnit';

export default IndividualUnit;
